import { render, staticRenderFns } from "./Submitted.vue?vue&type=template&id=9153936a&scoped=true&"
import script from "./Submitted.vue?vue&type=script&lang=js&"
export * from "./Submitted.vue?vue&type=script&lang=js&"
import style0 from "./Submitted.vue?vue&type=style&index=0&id=9153936a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9153936a",
  null
  
)

export default component.exports